import React, { useEffect, useState } from 'react'
import Input from 'Components/Input'
import PhoneInput from 'Components/PhoneInput'
import AutoComplete from 'Components/AutoComplete'
import Constants from 'EurestoFonction/Constants'
import Grid from '@material-ui/core/Grid'
import Data from 'EurestoClass/Data'
import User from 'EurestoClass/User'
import Utils from 'EurestoFonction/Utils'
import InputClient from 'EurestoComponents/InputClient'
import Select from 'Components/Select'
import Switch from 'Components/Switch'

export default React.memo(props => {

  const [object, setObject] = useState(props.object || { type: 'email' })
  const [key, setKey] = useState(Utils.getRandomNumber())
  const [disabled, setDisabled] = useState(props.disabled || false)

  const onChange = (data, name) => {
    const obj = {
      ...(object || {}),
      [name]: data
    }
    setObject(obj)
    props.onChange && props.onChange(EurestoClone(obj))
  }

  const onChangeUser = (data) => {
    const user = Data.get(Constants.module.CONFIGURATION, Constants.donnee.utilisateur, { id: data })
    if (user) {
      const obj = {
        ...(object || {}),
        config: {
          user_id: data,
          email_retour: user.email,
          portable_retour: user.portable
        }
      }
      setObject(obj)
      props.onChange && props.onChange(EurestoClone(obj))
    }
  }

  const onChangeConfig = (data, name) => {
    const obj = {
      ...(object || {}),
      config: {
        ...(object && object.config || {}),
        [name]: data
      }
    }
    setObject(obj)
    props.onChange && props.onChange(EurestoClone(obj))
  }

  useEffect(() => {
    if (!_.isEqual(props.object, object)) {
      setKey(Utils.getRandomNumber())
      setObject(props.object || {})
    }
  }, [props.object])

  return (
    <Grid key={key} container style={{ margin: 0, padding: 0 }} spacing={0} direction="column"
      justify="flex-start"
      alignItems="stretch">
      <Input
        autoFocus={!disabled}
        title={EurestoI18n.t('commun:Nom')}
        onChange={onChange}
        name={'libelle'}
        disabled={disabled}
        value={object.libelle !== undefined ? object.libelle : []}
      />
      {
        User.TypeAccess.get(Constants.access.EURESTO) &&
        <Select value={object.type} name={'type'} onChange={onChange}
          disabled={disabled} options={[{
            value: 'email',
            label: 'Email'
          }, {
            value: 'sms',
            label: 'Sms'
          }]} />
      }
      {object.type === 'sms' && <React.Fragment>
        <PhoneInput onChange={onChange}
          name={'portable'}
          disabled={disabled}
          value={object.portable} />
        {object.entite_id !== 1 &&
          <InputClient defaultSearch={{ type_contact_id: [4] }} name={'entite_id'} contact_id={object.entite_id}
            disabled={disabled}
            onChange={onChange} title={EurestoI18n.t('commun:Établissement')} />}
        <Switch checked={object.entite_id === 1} title={'Lier à Euresto ?'}
          disabled={disabled}
          onChange={() => setObject(o => ({ ...o, entite_id: o.entite_id === 1 ? undefined : 1 }))} />
        <AutoComplete
          disabled={disabled}
          title={'Utilisateur'}
          key={(object.config && (typeof object.config === 'string' && JSON.parse(object.config).user_id || object.config.user_id) || '') + '-user_id'}
          onChange={onChangeUser}
          data={object.config && (typeof object.config === 'string' && JSON.parse(object.config).user_id || object.config.user_id)}
          options={Data.list(Constants.module.CONFIGURATION, Constants.donnee.utilisateur, { archive_id: null }).map(u => ({
            value: u.id,
            label: u.libelle
          }))} />
        <PhoneInput onChange={onChangeConfig}
          key={(object.config && (typeof object.config === 'string' && JSON.parse(object.config).user_id || object.config.user_id) || '') + '-portable'}
          name={'portable_retour'}
          disabled={disabled}
          value={object.config && (typeof object.config === 'string' && JSON.parse(object.config).portable_retour || object.config.portable_retour) || ''} />
        <Input onChange={onChangeConfig} name={'email_retour'}
          key={(object.config && (typeof object.config === 'string' && JSON.parse(object.config).user_id || object.config.user_id) || '') + '-email'}
          disabled={disabled}
          value={object.config && (typeof object.config === 'string' && JSON.parse(object.config).email_retour || object.config.email_retour) || ''} />
      </React.Fragment>
      }
      {object.type === 'email' && <React.Fragment>
        <Switch checked={object.entite_id === 1} title={'Lier à Euresto ?'}
          disabled={disabled}
          onChange={() => setObject(o => ({ ...o, entite_id: o.entite_id === 1 ? undefined : 1 }))} />
        <AutoComplete
          disabled={disabled}
          title={'Utilisateur'}
          onChange={onChangeUser}
          data={object.config && (typeof object.config === 'string' && JSON.parse(object.config).user_id || object.config.user_id) || ''}
          options={Data.list(Constants.module.CONFIGURATION, Constants.donnee.utilisateur, { archive_id: null }).map(u => ({
            value: u.id,
            label: u.libelle
          }))} />
        <PhoneInput onChange={onChangeConfig}
          key={(object.config && (typeof object.config === 'string' && JSON.parse(object.config).user_id || object.config.user_id) || '') + '-portable'}
          name={'portable_retour'}
          disabled={disabled}
          value={object.config && (typeof object.config === 'string' && JSON.parse(object.config).portable_retour || object.config.portable_retour) || ''} />
        <Input onChange={onChangeConfig} name={'email_retour'}
          key={(object.config && (typeof object.config === 'string' && JSON.parse(object.config).user_id || object.config.user_id) || '') + '-email'}
          disabled={disabled}
          value={object.config && (typeof object.config === 'string' && JSON.parse(object.config).email_retour || object.config.email_retour) || ''} />
      </React.Fragment>
      }
    </Grid>
  )
}
)


// WEBPACK FOOTER //
// ./app/App/Module/Configuration/Component/SuiviDossier/Messagerie/form.js